import { SideEnum, type MarketDataSnapshot, type MarketDataSnapshotLevel, type Security } from '@talos/kyoko';
import Big from 'big.js';
import { getNormalizedOrderQty } from '../components/OMS/useGetOrderCurrency';

export function getExpectedFillPriceAndSize(
  security: Security | undefined,
  orderCurrency: string,
  marketDataSnapshot: MarketDataSnapshot | undefined,
  orderSide: SideEnum,
  orderQty?: string
): {
  expectedFillQty: string | undefined;
  expectedFillPrice: string | undefined;
} {
  if (marketDataSnapshot == null || orderQty == null || orderQty === '') {
    return {
      expectedFillPrice: undefined,
      expectedFillQty: undefined,
    };
  }

  let levels: MarketDataSnapshotLevel[] | null = null;
  if (orderSide === SideEnum.Buy) {
    levels = marketDataSnapshot.Offers;
  } else if (orderSide === SideEnum.Sell) {
    levels = marketDataSnapshot.Bids;
  }

  if (levels == null || levels.length === 0) {
    return {
      expectedFillPrice: undefined,
      expectedFillQty: undefined,
    };
  }

  // Find first level with enough quantity for the order
  let i = 0;
  while (i < levels.length) {
    const level = levels[i];
    const levelQty: string | undefined = getNormalizedOrderQty({
      security,
      orderCurrency,
      size: level.Size ?? level.Amount,
    });
    const levelVWAP: string | undefined = level.VWAP;
    if (levelQty != null && levelVWAP != null && Big(levelQty).gte(orderQty)) {
      return {
        expectedFillQty: levelQty, // TODO: Use `orderQty` instead of `levelQty` and compute expected fill px ourselves
        expectedFillPrice: levelVWAP,
      };
    }
    i++;
  }

  // Order qty too large for book, so use all liquidity on the last level
  const level = levels[i - 1];
  const levelQty: string | undefined = getNormalizedOrderQty({
    security,
    orderCurrency,
    size: level.Size ?? level.Amount,
  });
  const levelVWAP: string | undefined = level.VWAP;
  if (levelQty != null && levelVWAP != null) {
    return {
      expectedFillQty: levelQty, // TODO: See above
      expectedFillPrice: levelVWAP,
    };
  }

  return {
    expectedFillQty: undefined,
    expectedFillPrice: undefined,
  };
}
